/* eslint-disable react-hooks/exhaustive-deps */
import { Divider, Grid, Stack, Typography } from "@mui/material";

import { dualLangInspectionNoteBusiness } from "api/bussiness/inspection-note/dual-lang-inspection-note/dual-lang-inspection-note-business";
import { PrintColorInspect } from "commons/enum/inspection";
import { StellaInspectionsPermission } from "commons/enum/permission";
import { numberFormatAsString } from "commons/ultilities";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { observer } from "mobx-react-lite";
import { isAlive } from "mobx-state-tree";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PropertyInfo } from "share-components/atomics/property-info";
import {
  EditButton,
  GoBackIconButton,
  PrintButton,
  RemoveButton,
} from "share-components/mui-wrap/button/action-button";
import { PageContentScrollableContainer } from "share-components/templates/page/page-content-container";
import { PageDetailContainer } from "share-components/templates/page/page-detail-container";
import { PageHeaderContainer } from "share-components/templates/page/page-header-container";
import { EditDualLangInspectionNote } from "../edit/edit";
import {
  createApprovalStandard,
  createHeightStandard,
  createLengthStandard,
  createPaperTypeInspectText,
  createPaperTypeStandard,
  createThicknessStandard,
  createWeightStandard,
  createWidthStandard,
  getLabelOfConclusionStatus,
  getLabelOfPrintColorInspection,
  getLabelOfStorageTemperature,
  getOthersStandard,
} from "../share";
import { DualLangInspectionNotePrintPreview } from "./print-preview";

export const DualLangInspectionNoteDetail = observer(() => {
  const { dualLangInspectionNoteId } = useParams();
  const {
    dualLangInspectionNoteManagement: {
      getDualLangInspectionNoteDetail,
      openEdit,
      dualLangInspectionPrintingManagement: { open },
    },
  } = useStores();
  useEffect(() => {
    if (dualLangInspectionNoteId) {
      getDualLangInspectionNoteDetail(dualLangInspectionNoteId);
    }
  }, [getDualLangInspectionNoteDetail, dualLangInspectionNoteId]);
  return (
    <PageDetailContainer>
      <PageHeaderContainer direction={"row"} justifyContent={"space-between"}>
        <Header></Header>
      </PageHeaderContainer>
      <PageContentScrollableContainer>
        <Content></Content>
      </PageContentScrollableContainer>

      <>
        {openEdit && <EditDualLangInspectionNote></EditDualLangInspectionNote>}
      </>
      <>{open && <DualLangInspectionNotePrintPreview />}</>
    </PageDetailContainer>
  );
});
type HeaderProps = {};
const Header = observer((props: HeaderProps) => {
  const {
    dualLangInspectionNoteManagement: {
      dualLangInspectionNoteDetail,
      setProp: setDualLangInspectionNoteManagementProp,
      dualLangInspectionPrintingManagement,
    },
    deleteConfirmationStore: { setProp, setDeletionCallback },
  } = useStores();
  const navigate = useNavigate();
  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);
  const onDelete = useCallback(
    async (id: string) => {
      if (id) {
        await dualLangInspectionNoteBusiness.delete(id);
        goBack();
      }
    },
    [goBack]
  );
  const removeHandler = useCallback(() => {
    setProp("open", true);
    setDeletionCallback(() => {
      if (!dualLangInspectionNoteDetail?.id) return;
      onDelete(dualLangInspectionNoteDetail?.id);
    });
  }, [dualLangInspectionNoteDetail, onDelete, setDeletionCallback, setProp]);

  const editHandler = useCallback(() => {
    setDualLangInspectionNoteManagementProp("openEdit", true);
  }, [setDualLangInspectionNoteManagementProp]);

  const openPrintPreviewHandler = useCallback(() => {
    dualLangInspectionPrintingManagement.setProp("open", true);
  }, [dualLangInspectionPrintingManagement]);

  return (
    <>
      <Stack
        direction={"row"}
        justifyItems={"center"}
        spacing={1}
        alignItems={"center"}
      >
        <GoBackIconButton onClick={goBack}></GoBackIconButton>
        <Typography variant="subtitle2">{`Thông tin chi tiết `}</Typography>
      </Stack>
      <Stack direction={"row"} justifyItems={"center"} spacing={1}>
        {/* <ExportExcelButton></ExportExcelButton> */}
        <PrintButton
          accessPermission={[StellaInspectionsPermission.Print]}
          onClick={openPrintPreviewHandler}
        >
          Phiếu kiểm nghiệm
        </PrintButton>
        <RemoveButton
          accessPermission={[StellaInspectionsPermission.Delete]}
          onClick={removeHandler}
        ></RemoveButton>
        <EditButton
          accessPermission={[StellaInspectionsPermission.Update]}
          onClick={editHandler}
        ></EditButton>
      </Stack>
    </>
  );
});

const Content = observer(() => {
  const {
    dualLangInspectionNoteManagement: { dualLangInspectionNoteDetail },
  } = useStores();

  const firstItem = useMemo(() => {
    if (
      dualLangInspectionNoteDetail &&
      isAlive(dualLangInspectionNoteDetail) &&
      dualLangInspectionNoteDetail?.items &&
      dualLangInspectionNoteDetail?.items.length > 0 &&
      isAlive(dualLangInspectionNoteDetail?.items)
    ) {
      return dualLangInspectionNoteDetail?.items?.[0];
    }
    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dualLangInspectionNoteDetail,
    dualLangInspectionNoteDetail?.items,
    JSON.stringify(dualLangInspectionNoteDetail?.items),
  ]);

  return (
    <Stack>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <PropertyInfo
            title="Ngày kiểm nghiệm:"
            value={dateTimeDisplay(
              dualLangInspectionNoteDetail?.inspectionDate || ""
            )}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Số phiếu:"
            value={dualLangInspectionNoteDetail?.number || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Tên khách hàng:"
            value={dualLangInspectionNoteDetail?.customer?.dealingName || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Tên sản phẩm:"
            value={
              dualLangInspectionNoteDetail?.items?.[0]?.product?.name || ""
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Mã sản phẩm:"
            value={
              dualLangInspectionNoteDetail?.items?.[0]?.product?.code || ""
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Ngày đặt hàng:"
            value={dateTimeDisplay(
              dualLangInspectionNoteDetail?.purchaseOrder?.poDate || ""
            )}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Số đơn đặt hàng:"
            value={dualLangInspectionNoteDetail?.purchaseOrder?.poNumber || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Số lượng đặt hàng:"
            value={
              (dualLangInspectionNoteDetail?.orderQuantity &&
                numberFormatAsString(
                  dualLangInspectionNoteDetail?.orderQuantity.toString()
                )) ||
              ""
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Ngày sản xuất:"
            value={dateTimeDisplay(
              (dualLangInspectionNoteDetail?.workOrderPO?.date ?? dualLangInspectionNoteDetail?.workOrder?.date) || ""
            )}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Số lô sản xuất:"
            value={(dualLangInspectionNoteDetail?.workOrderPO?.woNumber ?? dualLangInspectionNoteDetail?.workOrder?.woNumber) || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Số lượng giao hàng:"
            value={
              (dualLangInspectionNoteDetail?.deliveredQuantity &&
                numberFormatAsString(
                  dualLangInspectionNoteDetail?.deliveredQuantity.toString()
                )) ||
              ""
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Số lượng thùng (Kiện):"
            // value={
            //   (dualLangInspectionNoteDetail?.packagesQuantity &&
            //     numberFormatAsString(
            //       dualLangInspectionNoteDetail?.packagesQuantity.toString()
            //     )) ||
            //   ""
            // }
            value={dualLangInspectionNoteDetail?.packagesQuantity || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Số Lượng /Thùng (Kiện):"
            value={
              (dualLangInspectionNoteDetail?.quantityPerPackage &&
                numberFormatAsString(
                  dualLangInspectionNoteDetail?.quantityPerPackage.toString()
                )) ||
              ""
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Số Lượng Mẫu Kiểm:"
            // value={
            //   (dualLangInspectionNoteDetail?.inspectionSamples &&
            //     numberFormatAsString(
            //       dualLangInspectionNoteDetail?.inspectionSamples.toString()
            //     )) ||
            //   ""
            // }
            value={dualLangInspectionNoteDetail?.inspectionSamples || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Điều Kiện Bảo Quản:"
            value={getLabelOfStorageTemperature(
              dualLangInspectionNoteDetail?.storageTemperature || ""
            )}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Hạn Sử Dụng:"
            value={dualLangInspectionNoteDetail?.expireDateText || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Người kiểm nghiệm:"
            value={dualLangInspectionNoteDetail?.inspector || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Ghi chú:"
            value={dualLangInspectionNoteDetail?.note || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={12}>
          <Divider sx={{ fontWeight: 600 }}>Chi tiết kiểm nghiệm</Divider>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Tiêu chuẩn - Loại giấy:"
            value={`${
              dualLangInspectionNoteDetail?.product &&
              createPaperTypeStandard(dualLangInspectionNoteDetail?.product)
            }`}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Kiểm nghiệm:"
            value={
              dualLangInspectionNoteDetail?.product &&
              createPaperTypeInspectText(
                dualLangInspectionNoteDetail?.product,
                numberFormatAsString(
                  firstItem?.paperTypeInspect?.toString() || ""
                )
              )
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Kết luận:"
            value={
              firstItem?.paperTypeResult &&
              getLabelOfConclusionStatus(firstItem?.paperTypeResult)
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={12}>
          <Divider></Divider>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Tiêu chuẩn - Độ dày:"
            value={`${
              dualLangInspectionNoteDetail?.product &&
              createThicknessStandard(dualLangInspectionNoteDetail?.product)
            }`}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Kiểm nghiệm:"
            value={`${numberFormatAsString(
              firstItem?.thicknessInspect?.toString() || ""
            )}mm`}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Kết luận:"
            value={
              firstItem?.thicknessResult &&
              getLabelOfConclusionStatus(firstItem?.thicknessResult)
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={12}>
          <Divider></Divider>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Tiêu chuẩn - Trọng lượng:"
            value={`${
              dualLangInspectionNoteDetail?.product &&
              createWeightStandard(dualLangInspectionNoteDetail?.product)
            }`}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Kiểm nghiệm:"
            value={`${numberFormatAsString(
              firstItem?.weightInspect?.toString() || ""
            )}gram`}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Kết luận:"
            value={
              firstItem?.weightResult &&
              getLabelOfConclusionStatus(firstItem?.weightResult)
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={12}>
          <Divider></Divider>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Tiêu chuẩn - Chiều dài:"
            value={`${
              dualLangInspectionNoteDetail?.product &&
              createLengthStandard(dualLangInspectionNoteDetail?.product)
            }`}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Kiểm nghiệm:"
            value={`${numberFormatAsString(
              firstItem?.lengthInspect?.toString() || ""
            )}mm`}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Kết luận:"
            value={
              firstItem?.lengthResult &&
              getLabelOfConclusionStatus(firstItem?.lengthResult)
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={12}>
          <Divider></Divider>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Tiêu chuẩn - Chiều rộng:"
            value={`${
              dualLangInspectionNoteDetail?.product &&
              createWidthStandard(dualLangInspectionNoteDetail?.product)
            }`}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Kiểm nghiệm:"
            value={`${numberFormatAsString(
              firstItem?.widthInspect?.toString() || ""
            )}mm`}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Kết luận:"
            value={
              firstItem?.widthResult &&
              getLabelOfConclusionStatus(firstItem?.widthResult)
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={12}>
          <Divider></Divider>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Tiêu chuẩn - Chiều Cao:"
            value={`${
              dualLangInspectionNoteDetail?.product &&
              createHeightStandard(dualLangInspectionNoteDetail?.product)
            }`}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Kiểm nghiệm:"
            value={`${numberFormatAsString(
              firstItem?.heightInspect?.toString() || ""
            )}mm`}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Kết luận:"
            value={
              firstItem?.heightResult &&
              getLabelOfConclusionStatus(firstItem?.heightResult)
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={12}>
          <Divider></Divider>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Tiêu chuẩn - Mẫu ký duyệt:"
            value={`${
              dualLangInspectionNoteDetail?.product &&
              createApprovalStandard(dualLangInspectionNoteDetail?.product)
            }`}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Kiểm nghiệm:"
            value={`${firstItem?.approvalInspect}`}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Kết luận:"
            value={
              firstItem?.approvalResult &&
              getLabelOfConclusionStatus(firstItem?.approvalResult)
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={12}>
          <Divider></Divider>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Tiêu chuẩn - Màu sắc in ấn:"
            value={`${
              dualLangInspectionNoteDetail?.product &&
              createApprovalStandard(dualLangInspectionNoteDetail?.product)
            }`}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Kiểm nghiệm:"
            value={`${
              firstItem?.printColorInspect &&
              getLabelOfPrintColorInspection(
                firstItem?.printColorInspect as PrintColorInspect
              )
            }`}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Kết luận:"
            value={
              firstItem?.printColorResult &&
              getLabelOfConclusionStatus(firstItem?.printColorResult)
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={12}>
          <Divider></Divider>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Tiêu chuẩn - Ngoại quan:"
            value={`${firstItem?.appearanceInspectionStandard || ""}`}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Kiểm nghiệm:"
            value={`${firstItem?.appearanceInspect || ""}`}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Kết luận:"
            value={
              firstItem?.appearanceResult &&
              getLabelOfConclusionStatus(firstItem?.appearanceResult)
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={12}>
          <Divider></Divider>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Tiêu chuẩn - khác:"
            value={`${
              firstItem?.product?.dimensionWeight != null
                ? getOthersStandard(firstItem?.product?.dimensionWeight)
                : ""
            }`}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Kiểm nghiệm:"
            value={`${firstItem?.otherStandardInspect || ""}`}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={4}>
          <PropertyInfo
            title="Kết luận:"
            value={
              firstItem?.otherStandardResult &&
              getLabelOfConclusionStatus(firstItem?.otherStandardResult)
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={12}>
          <Divider></Divider>
        </Grid>

        <Grid item xs={12}>
          <PropertyInfo
            title="Kết luận đánh giá:"
            value={firstItem?.conclusion || ""}
          ></PropertyInfo>
        </Grid>
      </Grid>
    </Stack>
  );
});
